var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 12L0 6L6 0L7.4 1.4L2.8 6L7.4 10.6L6 12Z","fill":"black"}));
}

ChevronLeft.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
